(async () => {

  if (!customElements.get('cart-drawer-collection-swiper')) {

    const { default: Swiper, Mousewheel } = await import("swiper");

    Swiper.use([
      Mousewheel
    ]);

    class cartDrawerCollection extends HTMLElement {
      constructor() {
        super();
        this.swiperElement = this.querySelector('[data-swiper]');
        this.swiperOptions = {
          loop: false,
          autoplay: false,
          mousewheel: true,
          spaceBetween: 0,
          slidesPerView: 2,
          threshold: 10,
          breakpoints: {
            360: {
              slidesPerView: 2.2
            },
            768: {
              slidesPerView:  2.1
            }
          }
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
        }

      }

    }

    window.cartDrawerCollection = cartDrawerCollection;

    customElements.define('cart-drawer-collection-swiper', cartDrawerCollection);

  }

})();